const FALLBACK = '/dashboard';

/**
 * Validate a `returnTo` value is a safe, same-origin relative path.
 * Returns `fallback` for nullish, empty, or potentially malicious values
 * (absolute URLs, protocol-relative URLs, etc.).
 */
export function safeReturnTo(
  value: string | null | undefined,
  fallback: string = FALLBACK
): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return fallback;
  }
  return value;
}

/** Build a URL string with `?returnTo=` appended when the path is worth preserving. */
export function appendReturnTo(base: string, returnTo: string | null | undefined): string {
  const safe = returnTo && returnTo !== FALLBACK ? returnTo : null;
  if (!safe) {
    return base;
  }
  return `${base}?returnTo=${encodeURIComponent(safe)}`;
}
